import type { ClientInfo } from '@neosocial/protocol';
import { desktopBridge } from '../lib/config';
import { thisDevice } from '../lib/device';

/**
 * How Settings › Devices names this session: the browser (on the web) and
 * the system. Every request that starts a session sends it: sign-up,
 * sign-in, the two-step step and account recovery.
 */
export function clientInfo(): ClientInfo {
  const bridge = desktopBridge();
  const device = thisDevice();
  return {
    client: bridge ? 'desktop' : 'web',
    ...(!bridge && device.browser ? { device_name: device.browser } : {}),
    os: device.os ?? (navigator.platform || undefined),
    app_version: bridge?.appVersion ?? '0.1.0',
  };
}
